(function () {
  'use strict';

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      var ownKeys = Object.keys(source);

      if (typeof Object.getOwnPropertySymbols === 'function') {
        ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
          return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
      }

      ownKeys.forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    }

    return target;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized(self);
  }

  /**
   * Plugin base class
   * 
   */
  var Plugin =
  /*#__PURE__*/
  function () {
    function Plugin(element, options) {
      _classCallCheck(this, Plugin);

      _defineProperty(this, "$element", void 0);

      _defineProperty(this, "options", void 0);

      this.$element = $(element);
      this.options = _objectSpread({}, this.constructor.defaults, options, this.$element.data());
      this.init();
    } // eslint-disable-next-line class-methods-use-this


    _createClass(Plugin, [{
      key: "init",
      value: function init() {
        throw new Error('You have to implement the method init!');
      } // eslint-disable-next-line class-methods-use-this

    }, {
      key: "update",
      value: function update() {}
    }, {
      key: "setOptions",
      value: function setOptions(options) {
        this.options = _objectSpread({}, this.options, options);
        this.update();
      }
    }]);

    return Plugin;
  }();

  _defineProperty(Plugin, "code", void 0);

  _defineProperty(Plugin, "key", '');

  _defineProperty(Plugin, "defaults", {});
  var register = function register(Descendant) {
    $.fn[Descendant.code] = function pluginGenerator(options) {
      return this.each(function elementFinder() {
        if (!$.data(this, Descendant.key)) {
          $.data(this, Descendant.key, new Descendant(this, options));
        } else {
          $.data(this, Descendant.key).setOptions(options);
        }
      });
    };
  };

  var Toolbar =
  /*#__PURE__*/
  function (_Plugin) {
    _inherits(Toolbar, _Plugin);

    function Toolbar(element, options) {
      var _this;

      _classCallCheck(this, Toolbar);

      if (!Toolbar.instance) {
        _this = _possibleConstructorReturn(this, _getPrototypeOf(Toolbar).call(this, element, options));
        Toolbar.instance = _assertThisInitialized(_assertThisInitialized(_this));
      }

      return _possibleConstructorReturn(_this, Toolbar.instance);
    }

    _createClass(Toolbar, [{
      key: "init",
      value: function init() {
        var _this2 = this;

        this.options.index = this.getIndex(); // get index from the current value.

        this.update(); // and update UI.

        var $html = $('html');
        var $toolbar = $('.toolbar'); // Use this.$element for non global behavior

        var $prev = $(Toolbar.buttons.decrease); // Use this.$element.find for non global behavior

        var $next = $(Toolbar.buttons.increase); // Use this.$element.find for non global behavior

        var $contrast = $(Toolbar.buttons.contrast); // Use this.$element.find for non global behavior

        var $toggle = $(Toolbar.buttons.toggler); // Use this.$element.find for non global behavior

        var storedContrast = !!localStorage.getItem(Toolbar.storageKeyPaths.contrast);
        $html.toggleClass(this.options.contrast, storedContrast);
        $contrast.on('click', function (e) {
          e.preventDefault();
          $(e.currentTarget).toggleClass('active');
          $html.toggleClass(_this2.options.contrast);

          if ($html.hasClass(_this2.options.contrast)) {
            localStorage.setItem(Toolbar.storageKeyPaths.contrast, 'active');
          } else {
            localStorage.removeItem(Toolbar.storageKeyPaths.contrast);
          }
        }); // show / hide - mobile

        $toggle.on('click', function (e) {
          e.preventDefault();
          $toolbar.toggleClass('active');
        });
        $prev.on('click', function (e) {
          e.preventDefault();

          if (!$prev.hasClass('disabled') && _this2.options.index > 0) {
            _this2.options.index = _this2.getIndex() - 1;
            _this2.options.value = _this2.options.values[_this2.options.index];

            _this2.update();

            _this2.$element.trigger(Toolbar.changeEvent, _this2.options.value);
          }
        });
        $next.on('click', function (e) {
          e.preventDefault();

          if (!$next.hasClass('disabled') && _this2.options.index < _this2.options.values.length) {
            _this2.options.index = _this2.getIndex() + 1;
            _this2.options.value = _this2.options.values[_this2.options.index];

            _this2.update();

            _this2.$element.trigger(Toolbar.changeEvent, _this2.options.value);
          }
        });
      } // #

    }, {
      key: "getIndex",
      value: function getIndex() {
        return (this.options.values || []).indexOf(this.options.value);
      } // #

    }, {
      key: "update",
      value: function update() {
        $('html').css({
          fontSize: this.options.value
        }).removeClass(this.options.classes.join(' ')).addClass(this.options.classes[this.options.index]);
        localStorage.setItem(Toolbar.storageKeyPaths.index, this.options.index);
        var $prev = $(Toolbar.buttons.decrease); // Use this.$element.find for non global behavior

        var $next = $(Toolbar.buttons.increase); // Use this.$element.find for non global behavior

        $prev.removeClass('disabled');
        $next.removeClass('disabled');

        if (this.options.index === 0) {
          $prev.addClass('disabled');
        }

        if (this.options.index === this.options.values.length - 1) {
          $next.addClass('disabled');
        }

        this.updateNavbar();
      }
    }, {
      key: "updateNavbar",
      value: function updateNavbar() {
        var $nav = $('.navbar');
        var navbarExpandClass = localStorage.getItem(Toolbar.storageKeyPaths.expand);

        if (!navbarExpandClass) {
          navbarExpandClass = $nav.attr('class').split(' ').find(function (item) {
            return /navbar-expand-*/.test(item);
          }) || Toolbar.defaultExpand;
          localStorage.setItem(Toolbar.storageKeyPaths.expand, navbarExpandClass);
        }

        if (this.options.index === 0) {
          $nav.addClass(localStorage.getItem(Toolbar.storageKeyPaths.expand) || Toolbar.defaultExpand);
        }

        if (this.options.index > 0) {
          $nav.removeClass(navbarExpandClass);
        }
      }
    }]);

    return Toolbar;
  }(Plugin);

  _defineProperty(Toolbar, "code", 'toolbar');

  _defineProperty(Toolbar, "key", 'gl.toolbar');

  _defineProperty(Toolbar, "instance", void 0);

  _defineProperty(Toolbar, "defaults", {
    value: '16px',
    index: 0,
    values: ['16px', '20px', '24px'],
    classes: ['a11y-font-0', 'a11y-font-1', 'a11y-font-2'],
    contrast: 'a11y-contrast'
  });

  _defineProperty(Toolbar, "storageKey", 'gob.cl:toolbar');

  _defineProperty(Toolbar, "changeEvent", 'change.gl.toolbar');

  _defineProperty(Toolbar, "buttons", {
    contrast: '.toolbar-behavior-contrast',
    decrease: '.toolbar-behavior-decrease',
    increase: '.toolbar-behavior-increase',
    toggler: '.toolbar-toggler'
  });

  _defineProperty(Toolbar, "defaultExpand", 'navbar-expand-lg');

  _defineProperty(Toolbar, "storageKeyPaths", {
    contrast: "".concat(Toolbar.storageKey, ".contrast"),
    index: "".concat(Toolbar.storageKey, ".index"),
    expand: "".concat(Toolbar.storageKey, ".expand")
  });

  register(Toolbar);

  if (!window.rsConf) {
    window.rsConf = {
      general: {
        usePost: true
      },
      ui: {}
    };
  } // TODO: refactor this.


  if (!window.rsConf.ui) {
    window.rsConf.ui = {};
  }

  window.rsConf.ui.rsbtnClass = 'rsbtn-gobcl-skin';
  window.rsConf.ui.player = ['<span class="rsbtn_box">', ' <a href="javascript:void(0);" class="rsbtn_pause rsimg rspart rsbutton">', '   <span class="toolbar-btn-icon-content">', '     <em class="cl cl-pause"></em>', '     <em class="cl cl-play"></em>', '   </span> ', ' </a>', ' <span class="rsbtn_progress_container rspart">', '   <span class="rsbtn_progress_played"></span>', ' </span>', ' <a href="javascript:void(0);" class="rsbtn_dl rsimg rspart rsbutton">', '   <span class="toolbar-btn-icon-content">', '     <i class="cl cl-download"></i>', '   </span> ', ' </a>', ' <a href="javascript:void(0);" class="rsbtn_closer rsimg rspart rsbutton">', '   <span class="toolbar-btn-icon-content">', '     <i class="cl cl-close"></i>', '   </span> ', ' </a>', ' <span class="rsdefloat"></span>', '</span>'];

  var PseudoBackground =
  /*#__PURE__*/
  function (_Plugin) {
    _inherits(PseudoBackground, _Plugin);

    function PseudoBackground() {
      _classCallCheck(this, PseudoBackground);

      return _possibleConstructorReturn(this, _getPrototypeOf(PseudoBackground).apply(this, arguments));
    }

    _createClass(PseudoBackground, [{
      key: "init",
      value: function init() {
        var $source = this.$element.find('.pseudo-src').addClass('d-none');
        this.$element.css('background-image', "url(\"".concat($source.attr('src'), "\")"));
      }
    }]);

    return PseudoBackground;
  }(Plugin);

  _defineProperty(PseudoBackground, "code", 'pseudoBackground');

  _defineProperty(PseudoBackground, "key", 'gl.pseudo-background');

  register(PseudoBackground);

  /* eslint-disable quote-props */
  var accentMap = {
    'áº': 'a',
    'Ã': 'a',
    'Ã¡': 'a',
    'Ã': 'a',
    'Ã ': 'a',
    'Ä': 'a',
    'Ä': 'a',
    'áº®': 'a',
    'áº¯': 'a',
    'áº°': 'a',
    'áº±': 'a',
    'áº´': 'a',
    'áºµ': 'a',
    'áº²': 'a',
    'áº³': 'a',
    'Ã': 'a',
    'Ã¢': 'a',
    'áº¤': 'a',
    'áº¥': 'a',
    'áº¦': 'a',
    'áº§': 'a',
    'áºª': 'a',
    'áº«': 'a',
    'áº¨': 'a',
    'áº©': 'a',
    'Ç': 'a',
    'Ç': 'a',
    'Ã': 'a',
    'Ã¥': 'a',
    'Çº': 'a',
    'Ç»': 'a',
    'Ã': 'a',
    'Ã¤': 'a',
    'Ç': 'a',
    'Ç': 'a',
    'Ã': 'a',
    'Ã£': 'a',
    'È¦': 'a',
    'È§': 'a',
    'Ç ': 'a',
    'Ç¡': 'a',
    'Ä': 'a',
    'Ä': 'a',
    'Ä': 'a',
    'Ä': 'a',
    'áº¢': 'a',
    'áº£': 'a',
    'È': 'a',
    'È': 'a',
    'È': 'a',
    'È': 'a',
    'áº ': 'a',
    'áº¡': 'a',
    'áº¶': 'a',
    'áº·': 'a',
    'áº¬': 'a',
    'áº­': 'a',
    'á¸': 'a',
    'á¸': 'a',
    'Èº': 'a',
    'â±¥': 'a',
    'Ç¼': 'a',
    'Ç½': 'a',
    'Ç¢': 'a',
    'Ç£': 'a',
    'á¸': 'b',
    'á¸': 'b',
    'á¸': 'b',
    'á¸': 'b',
    'á¸': 'b',
    'á¸': 'b',
    'É': 'b',
    'Æ': 'b',
    'áµ¬': 'b',
    'Æ': 'b',
    'É': 'b',
    'Æ': 'b',
    'Æ': 'b',
    'Ä': 'c',
    'Ä': 'c',
    'Ä': 'c',
    'Ä': 'c',
    'Ä': 'c',
    'Ä': 'c',
    'Ä': 'c',
    'Ä': 'c',
    'Ã': 'c',
    'Ã§': 'c',
    'á¸': 'c',
    'á¸': 'c',
    'È»': 'c',
    'È¼': 'c',
    'Æ': 'c',
    'Æ': 'c',
    'É': 'c',
    'Ä': 'd',
    'Ä': 'd',
    'á¸': 'd',
    'á¸': 'd',
    'á¸': 'd',
    'á¸': 'd',
    'á¸': 'd',
    'á¸': 'd',
    'á¸': 'd',
    'á¸': 'd',
    'á¸': 'd',
    'á¸': 'd',
    'Ä': 'd',
    'Ä': 'd',
    'áµ­': 'd',
    'Æ': 'd',
    'É': 'd',
    'Æ': 'd',
    'É': 'd',
    'Æ': 'd',
    'Æ': 'd',
    'È¡': 'd',
    'Ã°': 'd',
    'Ã': 'e',
    'Æ': 'e',
    'Æ': 'e',
    'Ç': 'e',
    'Ã©': 'e',
    'Ã': 'e',
    'Ã¨': 'e',
    'Ä': 'e',
    'Ä': 'e',
    'Ã': 'e',
    'Ãª': 'e',
    'áº¾': 'e',
    'áº¿': 'e',
    'á»': 'e',
    'á»': 'e',
    'á»': 'e',
    'á»': 'e',
    'á»': 'e',
    'á»': 'e',
    'Ä': 'e',
    'Ä': 'e',
    'Ã': 'e',
    'Ã«': 'e',
    'áº¼': 'e',
    'áº½': 'e',
    'Ä': 'e',
    'Ä': 'e',
    'È¨': 'e',
    'È©': 'e',
    'á¸': 'e',
    'á¸': 'e',
    'Ä': 'e',
    'Ä': 'e',
    'Ä': 'e',
    'Ä': 'e',
    'á¸': 'e',
    'á¸': 'e',
    'á¸': 'e',
    'á¸': 'e',
    'áºº': 'e',
    'áº»': 'e',
    'È': 'e',
    'È': 'e',
    'È': 'e',
    'È': 'e',
    'áº¸': 'e',
    'áº¹': 'e',
    'á»': 'e',
    'á»': 'e',
    'á¸': 'e',
    'á¸': 'e',
    'á¸': 'e',
    'á¸': 'e',
    'É': 'e',
    'É': 'e',
    'É': 'e',
    'É': 'e',
    'á¸': 'f',
    'á¸': 'f',
    'áµ®': 'f',
    'Æ': 'f',
    'Æ': 'f',
    'Ç´': 'g',
    'Çµ': 'g',
    'Ä': 'g',
    'Ä': 'g',
    'Ä': 'g',
    'Ä': 'g',
    'Ç¦': 'g',
    'Ç§': 'g',
    'Ä ': 'g',
    'Ä¡': 'g',
    'Ä¢': 'g',
    'Ä£': 'g',
    'á¸ ': 'g',
    'á¸¡': 'g',
    'Ç¤': 'g',
    'Ç¥': 'g',
    'Æ': 'g',
    'É ': 'g',
    'Ä¤': 'h',
    'Ä¥': 'h',
    'È': 'h',
    'È': 'h',
    'á¸¦': 'h',
    'á¸§': 'h',
    'á¸¢': 'h',
    'á¸£': 'h',
    'á¸¨': 'h',
    'á¸©': 'h',
    'á¸¤': 'h',
    'á¸¥': 'h',
    'á¸ª': 'h',
    'á¸«': 'h',
    'H': 'h',
    'Ì±': 'h',
    'áº': 'h',
    'Ä¦': 'h',
    'Ä§': 'h',
    'â±§': 'h',
    'â±¨': 'h',
    'Ã': 'i',
    'Ã­': 'i',
    'Ã': 'i',
    'Ã¬': 'i',
    'Ä¬': 'i',
    'Ä­': 'i',
    'Ã': 'i',
    'Ã®': 'i',
    'Ç': 'i',
    'Ç': 'i',
    'Ã': 'i',
    'Ã¯': 'i',
    'á¸®': 'i',
    'á¸¯': 'i',
    'Ä¨': 'i',
    'Ä©': 'i',
    'Ä°': 'i',
    'i': 'i',
    'Ä®': 'i',
    'Ä¯': 'i',
    'Äª': 'i',
    'Ä«': 'i',
    'á»': 'i',
    'á»': 'i',
    'È': 'i',
    'È': 'i',
    'È': 'i',
    'È': 'i',
    'á»': 'i',
    'á»': 'i',
    'á¸¬': 'i',
    'á¸­': 'i',
    'I': 'i',
    'Ä±': 'i',
    'Æ': 'i',
    'É¨': 'i',
    'Ä´': 'j',
    'Äµ': 'j',
    'J': 'j',
    'Ì': 'j',
    'Ç°': 'j',
    'È·': 'j',
    'É': 'j',
    'É': 'j',
    'Ê': 'j',
    'É': 'j',
    'Ê': 'j',
    'á¸°': 'k',
    'á¸±': 'k',
    'Ç¨': 'k',
    'Ç©': 'k',
    'Ä¶': 'k',
    'Ä·': 'k',
    'á¸²': 'k',
    'á¸³': 'k',
    'á¸´': 'k',
    'á¸µ': 'k',
    'Æ': 'k',
    'Æ': 'k',
    'â±©': 'k',
    'â±ª': 'k',
    'Ä¹': 'a',
    'Äº': 'l',
    'Ä½': 'l',
    'Ä¾': 'l',
    'Ä»': 'l',
    'Ä¼': 'l',
    'á¸¶': 'l',
    'á¸·': 'l',
    'á¸¸': 'l',
    'á¸¹': 'l',
    'á¸¼': 'l',
    'á¸½': 'l',
    'á¸º': 'l',
    'á¸»': 'l',
    'Å': 'l',
    'Å': 'l',
    'Ì£': 'l',
    'Ä¿': 'l',
    'Å': 'l',
    'È½': 'l',
    'Æ': 'l',
    'â± ': 'l',
    'â±¡': 'l',
    'â±¢': 'l',
    'É«': 'l',
    'É¬': 'l',
    'É­': 'l',
    'È´': 'l',
    'á¸¾': 'm',
    'á¸¿': 'm',
    'á¹': 'm',
    'á¹': 'm',
    'á¹': 'm',
    'á¹': 'm',
    'É±': 'm',
    'Å': 'n',
    'Å': 'n',
    'Ç¸': 'n',
    'Ç¹': 'n',
    'Å': 'n',
    'Å': 'n',
    'Ã': 'n',
    'Ã±': 'n',
    'á¹': 'n',
    'á¹': 'n',
    'Å': 'n',
    'Å': 'n',
    'á¹': 'n',
    'á¹': 'n',
    'á¹': 'n',
    'á¹': 'n',
    'á¹': 'n',
    'á¹': 'n',
    'Æ': 'n',
    'É²': 'n',
    'È ': 'n',
    'Æ': 'n',
    'É³': 'n',
    'Èµ': 'n',
    'N': 'n',
    'Ì': 'n',
    'n': 'n',
    'Ã': 'o',
    'Ã³': 'o',
    'Ã': 'o',
    'Ã²': 'o',
    'Å': 'o',
    'Å': 'o',
    'Ã': 'o',
    'Ã´': 'o',
    'á»': 'o',
    'á»': 'o',
    'á»': 'o',
    'á»': 'o',
    'á»': 'o',
    'á»': 'o',
    'á»': 'o',
    'á»': 'o',
    'Ç': 'o',
    'Ç': 'o',
    'Ã': 'o',
    'Ã¶': 'o',
    'Èª': 'o',
    'È«': 'o',
    'Å': 'o',
    'Å': 'o',
    'Ã': 'o',
    'Ãµ': 'o',
    'á¹': 'o',
    'á¹': 'o',
    'á¹': 'o',
    'á¹': 'o',
    'È¬': 'o',
    'È­': 'o',
    'È®': 'o',
    'È¯': 'o',
    'È°': 'o',
    'È±': 'o',
    'Ã': 'o',
    'Ã¸': 'o',
    'Ç¾': 'o',
    'Ç¿': 'o',
    'Çª': 'o',
    'Ç«': 'o',
    'Ç¬': 'o',
    'Ç­': 'o',
    'Å': 'o',
    'Å': 'o',
    'á¹': 'o',
    'á¹': 'o',
    'á¹': 'o',
    'á¹': 'o',
    'á»': 'o',
    'á»': 'o',
    'È': 'o',
    'È': 'o',
    'È': 'o',
    'È': 'o',
    'Æ ': 'o',
    'Æ¡': 'o',
    'á»': 'o',
    'á»': 'o',
    'á»': 'o',
    'á»': 'o',
    'á» ': 'o',
    'á»¡': 'o',
    'á»': 'o',
    'á»': 'o',
    'á»¢': 'o',
    'á»£': 'o',
    'á»': 'o',
    'á»': 'o',
    'á»': 'o',
    'á»': 'o',
    'Æ': 'o',
    'Éµ': 'o',
    'á¹': 'p',
    'á¹': 'p',
    'á¹': 'p',
    'á¹': 'p',
    'â±£': 'p',
    'Æ¤': 'p',
    'Æ¥': 'p',
    'P': 'p',
    'Ì': 'p',
    'p': 'p',
    'Ê ': 'q',
    'É': 'q',
    'É': 'q',
    'Å': 'r',
    'Å': 'r',
    'Å': 'r',
    'Å': 'r',
    'á¹': 'r',
    'á¹': 'r',
    'Å': 'r',
    'Å': 'r',
    'È': 'r',
    'È': 'r',
    'È': 'r',
    'È': 'r',
    'á¹': 'r',
    'á¹': 'r',
    'á¹': 'r',
    'á¹': 'r',
    'á¹': 'r',
    'á¹': 'r',
    'É': 'r',
    'É': 'r',
    'áµ²': 'r',
    'É¼': 'r',
    'â±¤': 'r',
    'É½': 'r',
    'É¾': 'r',
    'áµ³': 'r',
    'Ã': 's',
    'Å': 's',
    'Å': 's',
    'á¹¤': 's',
    'á¹¥': 's',
    'Å': 's',
    'Å': 's',
    'Å ': 's',
    'Å¡': 's',
    'á¹¦': 's',
    'á¹§': 's',
    'á¹ ': 's',
    'á¹¡': 's',
    'áº': 's',
    'Å': 's',
    'Å': 's',
    'á¹¢': 's',
    'á¹£': 's',
    'á¹¨': 's',
    'á¹©': 's',
    'È': 's',
    'È': 's',
    'Ê': 's',
    'S': 's',
    'Ì©': 's',
    's': 's',
    'Ã': 't',
    'Ã¾': 't',
    'Å¤': 't',
    'Å¥': 't',
    'T': 't',
    'áº': 't',
    'á¹ª': 't',
    'á¹«': 't',
    'Å¢': 't',
    'Å£': 't',
    'á¹¬': 't',
    'á¹­': 't',
    'È': 't',
    'È': 't',
    'á¹°': 't',
    'á¹±': 't',
    'á¹®': 't',
    'á¹¯': 't',
    'Å¦': 't',
    'Å§': 't',
    'È¾': 't',
    'â±¦': 't',
    'áµµ': 't',
    'Æ«': 't',
    'Æ¬': 't',
    'Æ­': 't',
    'Æ®': 't',
    'Ê': 't',
    'È¶': 't',
    'Ã': 'u',
    'Ãº': 'u',
    'Ã': 'u',
    'Ã¹': 'u',
    'Å¬': 'u',
    'Å­': 'u',
    'Ã': 'u',
    'Ã»': 'u',
    'Ç': 'u',
    'Ç': 'u',
    'Å®': 'u',
    'Å¯': 'u',
    'Ã': 'u',
    'Ã¼': 'u',
    'Ç': 'u',
    'Ç': 'u',
    'Ç': 'u',
    'Ç': 'u',
    'Ç': 'u',
    'Ç': 'u',
    'Ç': 'u',
    'Ç': 'u',
    'Å°': 'u',
    'Å±': 'u',
    'Å¨': 'u',
    'Å©': 'u',
    'á¹¸': 'u',
    'á¹¹': 'u',
    'Å²': 'u',
    'Å³': 'u',
    'Åª': 'u',
    'Å«': 'u',
    'á¹º': 'u',
    'á¹»': 'u',
    'á»¦': 'u',
    'á»§': 'u',
    'È': 'u',
    'È': 'u',
    'È': 'u',
    'È': 'u',
    'Æ¯': 'u',
    'Æ°': 'u',
    'á»¨': 'u',
    'á»©': 'u',
    'á»ª': 'u',
    'á»«': 'u',
    'á»®': 'u',
    'á»¯': 'u',
    'á»¬': 'u',
    'á»­': 'u',
    'á»°': 'u',
    'á»±': 'u',
    'á»¤': 'u',
    'á»¥': 'u',
    'á¹²': 'u',
    'á¹³': 'u',
    'á¹¶': 'u',
    'á¹·': 'u',
    'á¹´': 'u',
    'á¹µ': 'u',
    'É': 'u',
    'Ê': 'u',
    'á¹¼': 'v',
    'á¹½': 'v',
    'á¹¾': 'v',
    'á¹¿': 'v',
    'Æ²': 'v',
    'Ê': 'v',
    'áº': 'w',
    'áº': 'w',
    'áº': 'w',
    'áº': 'w',
    'Å´': 'w',
    'Åµ': 'w',
    'W': 'w',
    'Ì': 'w',
    'áº': 'w',
    'áº': 'w',
    'áº': 'w',
    'áº': 'w',
    'áº': 'w',
    'áº': 'w',
    'áº': 'w',
    'áº': 'x',
    'áº': 'x',
    'áº': 'x',
    'áº': 'x',
    'Ã': 'y',
    'Ã½': 'y',
    'á»²': 'y',
    'á»³': 'y',
    'Å¶': 'y',
    'Å·': 'y',
    'Y': 'y',
    'áº': 'y',
    'Å¸': 'y',
    'Ã¿': 'y',
    'á»¸': 'y',
    'á»¹': 'y',
    'áº': 'y',
    'áº': 'y',
    'È²': 'y',
    'È³': 'y',
    'á»¶': 'y',
    'á»·': 'y',
    'á»´': 'y',
    'á»µ': 'y',
    'Ê': 'y',
    'É': 'y',
    'É': 'y',
    'Æ³': 'y',
    'Æ´': 'y',
    'Å¹': 'z',
    'Åº': 'z',
    'áº': 'z',
    'áº': 'z',
    'Å½': 'z',
    'Å¾': 'z',
    'Å»': 'z',
    'Å¼': 'z',
    'áº': 'z',
    'áº': 'z',
    'áº': 'z',
    'áº': 'z',
    'Æµ': 'z',
    'Æ¶': 'z',
    'È¤': 'z',
    'È¥': 'z',
    'Ê': 'z',
    'Ê': 'z',
    'â±«': 'z',
    'â±¬': 'z',
    'Ç®': 'z',
    'Ç¯': 'z',
    'Æº': 'z',
    // Roman fullwidth ascii equivalents: 0xff00 to 0xff5e
    'ï¼': '2',
    'ï¼': '6',
    'ï¼¢': 'B',
    'ï¼¦': 'F',
    'ï¼ª': 'J',
    'ï¼®': 'N',
    'ï¼²': 'R',
    'ï¼¶': 'V',
    'ï¼º': 'Z',
    'ï½': 'b',
    'ï½': 'f',
    'ï½': 'j',
    'ï½': 'n',
    'ï½': 'r',
    'ï½': 'v',
    'ï½': 'z',
    'ï¼': '1',
    'ï¼': '5',
    'ï¼': '9',
    'ï¼¡': 'A',
    'ï¼¥': 'E',
    'ï¼©': 'I',
    'ï¼­': 'M',
    'ï¼±': 'Q',
    'ï¼µ': 'U',
    'ï¼¹': 'Y',
    'ï½': 'a',
    'ï½': 'e',
    'ï½': 'i',
    'ï½': 'm',
    'ï½': 'q',
    'ï½': 'u',
    'ï½': 'y',
    'ï¼': '0',
    'ï¼': '4',
    'ï¼': '8',
    'ï¼¤': 'D',
    'ï¼¨': 'H',
    'ï¼¬': 'L',
    'ï¼°': 'P',
    'ï¼´': 'T',
    'ï¼¸': 'X',
    'ï½': 'd',
    'ï½': 'h',
    'ï½': 'l',
    'ï½': 'p',
    'ï½': 't',
    'ï½': 'x',
    'ï¼': '3',
    'ï¼': '7',
    'ï¼£': 'C',
    'ï¼§': 'G',
    'ï¼«': 'K',
    'ï¼¯': 'O',
    'ï¼³': 'S',
    'ï¼·': 'W',
    'ï½': 'c',
    'ï½': 'g',
    'ï½': 'k',
    'ï½': 'o',
    'ï½': 's',
    'ï½': 'w'
  };
  var accentFold = (function (s) {
    if (!s) {
      return '';
    }

    var ret = '';

    for (var i = 0; i < s.length; i += 1) {
      ret += accentMap[s.charAt(i)] || s.charAt(i);
    }

    return ret;
  });

  var Search =
  /*#__PURE__*/
  function (_Plugin) {
    _inherits(Search, _Plugin);

    function Search() {
      _classCallCheck(this, Search);

      return _possibleConstructorReturn(this, _getPrototypeOf(Search).apply(this, arguments));
    }

    _createClass(Search, [{
      key: "init",
      value: function init() {
        var $input = this.$element.find('.form-control');
        var $cancel = this.$element.find(Search.buttons.cancel);
        $cancel.addClass('d-none');

        if ($input.val()) {
          $cancel.removeClass('d-none');
        }

        $input.on('input', function () {
          if ($input.val()) {
            $cancel.removeClass('d-none');
          } else {
            $cancel.addClass('d-none');
          }
        });
        $cancel.on('click', function () {
          $input.val('');
          $cancel.addClass('d-none');
        });
        this.configureViewFilterBehavior();
      }
    }, {
      key: "configureViewFilterBehavior",
      value: function configureViewFilterBehavior() {
        var _this = this;

        this.$element.find('.form-control').on('input', function (event) {
          var value = accentFold($(event.currentTarget).val());
          $(_this.options.scrappingClass).each(function (index, element) {
            var $element = $(element);
            $element.removeClass('d-none');

            if (accentFold($element.data(_this.options.scrappingValue)).search(new RegExp(value, 'gi')) === -1) {
              $element.addClass('d-none');
            }
          });

          _this.groupBehavior();
        }).end().find(Search.buttons.cancel).on('click', function () {
          $(_this.options.scrappingClass).each(function (index, element) {
            $(element).removeClass('d-none');

            _this.groupBehavior();
          });
        });
      }
    }, {
      key: "groupBehavior",
      value: function groupBehavior() {
        var _this2 = this;

        this.options.groups.forEach(function (group) {
          $(".search-not-found.not-found-".concat(group.substr(1))).toggleClass('not-found', $("".concat(_this2.options.scrappingClass).concat(group)).length === $("".concat(_this2.options.scrappingClass).concat(group, ".d-none")).length);
        });
      }
    }]);

    return Search;
  }(Plugin);

  _defineProperty(Search, "code", 'domSearch');

  _defineProperty(Search, "key", 'gl.search');

  _defineProperty(Search, "defaults", {
    scrappingValue: 'search-value',
    scrappingClass: '.searchable',
    groups: []
  });

  _defineProperty(Search, "buttons", {
    cancel: '.dom-search-behavior-cancel',
    search: '.dom-search-behavior-search'
  });

  register(Search);

  var Contingency =
  /*#__PURE__*/
  function (_Plugin) {
    _inherits(Contingency, _Plugin);

    function Contingency() {
      _classCallCheck(this, Contingency);

      return _possibleConstructorReturn(this, _getPrototypeOf(Contingency).apply(this, arguments));
    }

    _createClass(Contingency, [{
      key: "init",
      value: function init() {
        var _this = this;

        this.update();
        var $body = $('body');
        var $close = this.$element.find('.contingency-behavior-close');
        $close.on('click', function () {
          localStorage.setItem(Contingency.storageKeyPaths.state, 'active');
          $body.addClass('contingency-closed');
        });
        $(document).on('click', '.contingency-behavior-open', function () {
          localStorage.removeItem(Contingency.storageKeyPaths.state);
          $body.removeClass('contingency-closed');

          _this.setOptions({
            active: true
          });
        });
        $(document).on('click', '.contingency-behavior-change', function (e) {
          e.preventDefault();
          var $index = $(e.currentTarget);

          _this.internalUpdate($index.data('target'));
        });
      } // eslint-disable-next-line class-methods-use-this

    }, {
      key: "internalUpdate",
      value: function internalUpdate(target) {
        $('.contingency-item').addClass('d-none');
        $(target).removeClass('d-none');
        $('.contingency-index .contingency-item').removeClass('d-none');
        $(".contingency-index ".concat(target)).addClass('d-none');
        localStorage.setItem(Contingency.storageKeyPaths.current, target);
      }
    }, {
      key: "update",
      value: function update() {
        var $body = $('body');

        if (this.options.active) {
          $body.addClass('contingency-active').toggleClass('contingency-closed', !!localStorage.getItem(Contingency.storageKeyPaths.state));
          this.internalUpdate(localStorage.getItem(Contingency.storageKeyPaths.current) || Contingency.defaults.current);
        } else {
          $body.removeClass('contingency-active');
        }
      }
    }]);

    return Contingency;
  }(Plugin);

  _defineProperty(Contingency, "code", 'contingency');

  _defineProperty(Contingency, "key", 'gl.contingency');

  _defineProperty(Contingency, "storageKey", 'gob.cl:contingency');

  _defineProperty(Contingency, "storageKeyPaths", {
    state: "".concat(Contingency.storageKey, ".state"),
    current: "".concat(Contingency.storageKey, ".current")
  });

  _defineProperty(Contingency, "defaults", {
    current: '.contingency-1'
  });

  register(Contingency);

  var Onboarding =
  /*#__PURE__*/
  function (_Plugin) {
    _inherits(Onboarding, _Plugin);

    function Onboarding() {
      _classCallCheck(this, Onboarding);

      return _possibleConstructorReturn(this, _getPrototypeOf(Onboarding).apply(this, arguments));
    }

    _createClass(Onboarding, [{
      key: "init",
      value: function init() {
        this.update();
        var $body = $('body');
        var $dismiss = this.$element.find('.onboarding-behavior-dismiss');
        $dismiss.on('click', function () {
          localStorage.setItem(Onboarding.storageKey, 'active');
          $body.addClass('onboarding-closed');
        });
      }
    }, {
      key: "update",
      value: function update() {
        var $body = $('body');

        if (this.options.active && !localStorage.getItem(Onboarding.storageKey)) {
          $body.addClass('onboarding-active');
        } else {
          $body.removeClass('onboarding-active');
        }
      }
    }]);

    return Onboarding;
  }(Plugin);

  _defineProperty(Onboarding, "code", 'onboarding');

  _defineProperty(Onboarding, "key", 'gl.onboarding');

  _defineProperty(Onboarding, "storageKey", 'gob.cl:onboarding');

  register(Onboarding);

  /**
   * Smooth Scroll
   */
  var smoothScroll = (function () {
    var $body = $('body');
    $('a[href*="#"]') // Remove links that don't actually link to anything
    .not('[href="#"]').not('[href="#0"]').not('.not-smooth').click(function (event) {
      // On-page links
      if (window.location.pathname.replace(/^\//, '') === event.currentTarget.pathname.replace(/^\//, '') && window.location.hostname === event.currentTarget.hostname) {
        // Figure out element to scroll to
        var $target = $(event.currentTarget.hash);
        $target = $target.length ? $target : $("[name=".concat(event.currentTarget.hash.slice(1), "]")); // Does a scroll target exist?

        if ($target.length) {
          // Only prevent default if animation is actually gonna happen
          var scrollMemory = $(document).scrollTop();
          window.location.hash = event.currentTarget.hash;
          $(document).scrollTop(scrollMemory);
          $('.scroll-item').each(function (i, item) {
            var $scrollItem = $(item);

            if ($scrollItem.data('active')) {
              if ($scrollItem.data('active') === 'parent') {
                $scrollItem.parent().removeClass('active');
              } else {
                $($scrollItem.data('active')).removeClass('active');
              }
            } else {
              $(item).removeClass('active');
            }
          });
          var selector = ".scroll-item[href*='".concat(window.location.hash, "']");
          var $scrollItem = $(selector);

          if ($scrollItem.data('active')) {
            if ($scrollItem.data('active') === 'parent') {
              $scrollItem.parent().addClass('active');
            } else {
              $($scrollItem.data('active')).addClass('active');
            }
          } else {
            $scrollItem.addClass('active');
          }

          $('html, body').stop().animate({
            scrollTop: $target.offset().top - parseInt($($body.data('main') ? $body.data('main') : 'body').css('margin-top'), 10) - parseInt($body.data('offset') || 10, 10)
          }, 500, function () {
            // Callback after animation
            // Must change focus!
            var $realTarget = $($target);
            $realTarget.focus();

            if ($target.is(':focus')) {
              // Checking if the target was focused
              return false;
            }

            $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable

            $target.focus(); // Set focus again

            $target.addClass('active');
            return true;
          });
        }
      }
    });

    if (window.location.hash && window.location.hash !== '#') {
      var $target = $(window.location.hash);
      $target = $target.length ? $target : $("[name=".concat(window.location.hash.slice(1), "]"));

      if ($target.length) {
        $('.scroll-item').each(function (i, item) {
          var $scrollItem = $(item);

          if ($scrollItem.data('active')) {
            if ($scrollItem.data('active') === 'parent') {
              $scrollItem.parent().removeClass('active');
            } else {
              $($scrollItem.data('active')).removeClass('active');
            }
          } else {
            $(item).removeClass('active');
          }
        });
        var selector = ".scroll-item[href*='".concat(window.location.hash, "']");
        var $scrollItem = $(selector);

        if ($scrollItem.data('active')) {
          if ($scrollItem.data('active') === 'parent') {
            $scrollItem.parent().addClass('active');
          } else {
            $($scrollItem.data('active')).addClass('active');
          }
        } else {
          $scrollItem.addClass('active');
        }

        $('html, body').stop().animate({
          scrollTop: $target.offset().top - parseInt($($body.data('main') ? $body.data('main') : 'body').css('margin-top'), 10)
        }, 500, function () {
          // Callback after animation
          // Must change focus!
          var $realTarget = $($target);
          $realTarget.focus();

          if ($target.is(':focus')) {
            // Checking if the target was focused
            return false;
          }

          $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable

          $target.focus(); // Set focus again

          return true;
        });
      }
    }
  });

  /**
   * cover background support with data-attribute data-background.
   */
  var coverBackground = (function () {
    $('[data-background]').each(function (i, item) {
      if (!$(item).data('background-video')) {
        var $background = $('<div/>').addClass('contain-cover-background');

        if ($(item).data('background')) {
          if ($(item).data('opacity') || !$(item).data('inline')) {
            $background.css('background-image', "url(\"".concat($(item).data('background'), "\")"));
          } else {
            $(item).css('background-image', "url(\"".concat($(item).data('background'), "\")"));
          }
        } else {
          $(item).addClass('none');
        }

        if ($(item).data('opacity')) {
          $(item).append($background).addClass('contain-cover contain-cover-opacity');

          if ($(item).data('hover-disabled')) {
            $(item).addClass('hover-disabled');
          }
        } else if ($(item).data('inline')) {
          $(item).addClass('contain-cover contain-cover-background');

          if ($(item).data('background')) {
            $(item).css('background-image', "url(\"".concat($(item).data('background'), "\")"));
          } else {
            $(item).addClass('none');
          }
        } else {
          $(item).append($background).addClass('contain-cover');
        }
      } else {
        var $video = $('<video/>', {
          autoplay: 'autoplay',
          loop: 'loop',
          muted: true,
          poster: $(item).data('background')
        }).append($('<source/>', {
          src: $(item).data('background-video')
        }));
        $video[0].muted = true; // fix muted bug.

        $(item).append($('<div/>').append($video).addClass('video-container'), $('<div/>').addClass('contain-cover-opacity hover-disabled')).addClass('contain-cover contain-cover-video');
      }
    });
  });

  /**
   * Redirect behavior
   *
   * data-target-active-class: class for target on redirect, default-show.
   * data-timeout: time for redirect
   * data-body-class: class for body on redirect, default redirecting-active.
   */
  function redirecting () {
    $(document).on('click', '.redirecting-behavior-link', function (e) {
      e.preventDefault();
      var $link = $(e.currentTarget);
      $($link.data('target')).addClass($link.data('target-active-class') || 'show');
      $('body').addClass($link.data('body-class') || 'redirecting-active');
      setTimeout(function () {
        window.location = $link.attr('href');
      }, parseInt($link.data('timeout'), 10) || 3000);
    });
  }

  /* global $, document, moment, templates */

  /**
   * createInifiniteScroll - This function generates a creator of an infinite scroll
   * @param {string} urlTemplate - a link for ajax request
   * @param {function} urlTransformation -  function that adds additional parameters
   * to a requestUrl (optional), should accept url as parameter and return a new url.
   * Will be used only at first call, after it we just use what server sends us a 'next'
   * @param {string} templateName - a pug template which will be used to render results from server
   * @param {string} targetSelector - a selector to an existing container
   * @param {function} postLoadingTransformation - a function that is caused in the end
   * of the procedure (optional)
   * @returns {function} - a function that creates an infinite scroll
   */
  var createInfiniteScroll = (function (urlTemplate, urlTransformation, templateName, targetSelector, postLoadingTransformation) {
    return function factory() {
      // adding additional parameter to a request using a function-parameter
      var requestUrl = urlTransformation ? urlTransformation(urlTemplate) : urlTemplate;
      var isAlreadySent = false;
      var blockFutureRequests = false;
      var $loadingIndicator = $('.loading-indicator');
      $loadingIndicator.hide();
      document.addEventListener('scroll', function () {
        // This checks prevent additional request while the already sent one is not resolved
        if (isAlreadySent) {
          return;
        }

        if (!$loadingIndicator.length) {
          return;
        } // Here we check if a loading indicator is inside our viewport. If it is true
        // We can call a request


        var docViewTop = $(window).scrollTop();
        var docViewBottom = docViewTop + $(window).height(); // we use parent of an indicator because hidden elements do not have a height
        // but their container still has

        var elemTop = $loadingIndicator.parent().offset().top;
        var elemBottom = elemTop + $loadingIndicator.height();
        var shouldLoadMore = elemBottom <= docViewBottom - 10 && elemTop >= docViewTop;

        if (shouldLoadMore && !blockFutureRequests) {
          isAlreadySent = true;
          $loadingIndicator.show();
          window.GobCl.closeReadSpeaker();
          $.ajax(requestUrl, {
            success: function success(response) {
              // Setting a link for a consequent request
              requestUrl = response.next || requestUrl;
              var currentLanguage = response.current_language; // transforming a publishing date to a readable format for all results

              var articles = response.results.map(function (article) {
                var format;

                if (currentLanguage === 'es') {
                  format = 'LL';
                } else if (currentLanguage === 'en') {
                  format = 'll';
                }

                moment.locale(currentLanguage);
                return _objectSpread({}, article, {
                  publishing_date: moment(article.publishing_date).format(format)
                });
              }); // Generating DOM using a pug-template

              var newContent = templates[templateName]({
                articles: articles,
                currentLanguage: currentLanguage
              }); // Appending it to a current container

              $(targetSelector).append(newContent);
              isAlreadySent = false;
              $loadingIndicator.hide(); // post loading transformatiom

              if (postLoadingTransformation) postLoadingTransformation(); // If no more articles is loaded we block this function forever

              if (response.results.length === 0) {
                blockFutureRequests = true;
              }
            }
          });
        }
      });
    };
  });

  /**
   * create application context
   * @returns {{closeReadSpeaker: closeReadSpeaker, createInfiniteScroll: Function}}
   */

  var createContext = (function () {
    return {
      closeReadSpeaker: function closeReadSpeaker() {
        $('.rsbtn_closer').click();
      },
      createInfiniteScroll: createInfiniteScroll
    };
  });

  window.GobCL = createContext();
  $(function () {
    // plugins.
    $('.toolbar').toolbar();
    $('.pseudo-background').pseudoBackground();
    $('.dom-search').domSearch();
    $('.contingency').contingency();
    $('.onboarding').onboarding(); // behaviors.

    smoothScroll();
    coverBackground();
    redirecting();
  });

}());
//# sourceMappingURL=gob.cl.js.map
